import httpClient from "./httpClient";

const prefix = "/modules-permissions";

export interface ModulesPermission {
  id?: number;
  partnerId: number;
  modules: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateModulesPermissionDto {
  partnerId: number;
  modules: string[];
}

export interface UpdateModulesPermissionDto {
  modules: string[];
}

export async function createModulesPermission(data: CreateModulesPermissionDto) {
  return (await httpClient.post(prefix, data)).data;
}

export async function getAllModulesPermissions() {
  return (await httpClient.get(prefix)).data;
}

export async function getModulesPermissionById(id: number) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function getModulesPermissionByPartnerId(partnerId: number) {
  return (await httpClient.get(`${prefix}/partner/${partnerId}`)).data;
}

export async function updateModulesPermission(id: number, data: UpdateModulesPermissionDto) {
  return (await httpClient.patch(`${prefix}/${id}`, data)).data;
}

export async function deleteModulesPermission(id: number) {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}

export async function upsertModulesPermission(data: CreateModulesPermissionDto) {
  return (await httpClient.post(`${prefix}/upsert`, data)).data;
}

export async function applyModulesToAll(modules: string[]) {
  return (await httpClient.post(`${prefix}/apply-all`, { modules })).data;
}

export async function getReleasedAll() {
  return (await httpClient.get(`${prefix}/released-all`)).data;
}

export async function revertReleasedAll() {
  return (await httpClient.post(`${prefix}/revert-all`)).data;
}
